var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$checkPermission(_vm.$options.name, 'view'))?_c('b-card-code',{attrs:{"id":"companies","no-body":""}},[_c('AnalysisData')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }